import { HTMLAttributes } from 'react';
import { cn } from '@utils/cn';
import styles from '@/styles/components/Skeleton.module.scss';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

const variantStyles: Record<NonNullable<SkeletonProps['variant']>, string> = {
  text: styles.text!,
  circular: styles.circular!,
  rectangular: styles.rectangular!,
};

export const Skeleton = ({
  variant = 'rectangular',
  width,
  height,
  className,
  ...props
}: SkeletonProps) => {
  return (
    <div
      className={cn(styles.skeleton, variantStyles[variant], className)}
      style={{ width, height }}
      {...props}
    />
  );
};

export const SkeletonCard = () => {
  return (
    <div className={styles.skeletonCard}>
      <Skeleton variant="text" width="60%" height={24} />
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="80%" />
    </div>
  );
};

export const SkeletonTable = ({ rows = 5 }: { rows?: number }) => {
  return (
    <div className={styles.skeletonTable}>
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className={styles.skeletonRow}>
          <Skeleton width={40} height={40} variant="circular" />
          <div className={styles.skeletonRowContent}>
            <Skeleton width="40%" height={16} />
            <Skeleton width="60%" height={14} />
          </div>
        </div>
      ))}
    </div>
  );
};
